import Cookies from "js-cookie";
var uuid = require("uuid");

// state
const state = () => ({
  bookmarks: [],
});

// getters
const getters = {};

// actions
const actions = {
  setUserBookmarks({ commit }, fields) {
    commit('setUserBookmarks', fields);
  },
};

// mutations
const mutations = {
  setUserBookmarks(state, data) {
    state.bookmarks = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/vuex-store/modules/user.js